module.exports = __webpack_public_path__ + "img/typeselector_banner.b4761339.png";